import { inject, Injectable, signal } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';

import { API_ROUTES } from '../../../../../consts/api-routes.const';
import { HttpService } from '../../../../../services';
import { UserProfile } from '../interfaces/user-profile.interface';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly httpService: HttpService = inject(HttpService);

  public readonly email = signal<string | null>(sessionStorage.getItem('email'));
  private readonly userProfileCache = new Map<string, Observable<UserProfile | null>>();

  public clear(): void {
    this.userProfileCache.clear();
  }

  public getUserProfile(email: string): Observable<UserProfile | null> {
    const normalizedEmail: string = email.trim().toLowerCase();
    const cachedProfile: Observable<UserProfile | null> | undefined =
      this.userProfileCache.get(normalizedEmail);
    if (cachedProfile) {
      return cachedProfile;
    }

    return this.httpService
      .get<UserProfile>(API_ROUTES.USER.profile(email))
      .pipe(catchError((): Observable<null> => of(null)))
      .pipe(
        tap(
          (response): Map<string, Observable<UserProfile | null>> =>
            this.userProfileCache.set(normalizedEmail, of(response)),
        ),
      );
  }
}
